import * as React from 'react';
import {Suspense, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Route, Routes} from "react-router-dom";
import {ThemeProvider} from '@emotion/react';

import {ToolLoader} from '../../../shared/components';
import useTrackPageview from "../../../shared/utility/analyticsPageview";
import getSettings from "../helpers/api/getSettings";

import useRoutes from "../hooks/useRoutes";

import {setConfig, setTheme} from "../redux/applicationActions";
import {RootState} from "../redux/store";

import NewsIndex from "../views/NewsIndex";

const App = (): React.ReactElement => {
  const dispatch = useDispatch();
  const {routes} = useRoutes();
  const [loading, setLoading] = useState(true);
  const {base, theme} = useSelector((state: RootState) => {
    const {config, theme} = state.application;

    return {
      base: config.base,
      config,
      theme,
    }
  });

  useEffect(() => {
    getSettings()
      .then(({lead_form, settings, theme}): void => {
        const base = `/${settings.prefix}${settings.framed ? '/' + settings.framed : ''}`;

        dispatch(setConfig({...settings, base}, lead_form));
        dispatch(setTheme(theme));

        setLoading(false);
      });
  }, [dispatch]);

  useTrackPageview();

  return loading ? (
    <ToolLoader />
  ) : (
    <ThemeProvider theme={theme}>
      <Suspense fallback={null}>
        <Routes>
          {routes}

          <Route
            path={`${base}/*`}
            key={base}
            element={<NewsIndex />}
          />

          <Route
            path="/*"
            element={<h1>Deze pagina kon niet worden gevonden.</h1>}
          />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
